import React from "react";
type LogoMarkProps = {
  className?: string;
};

/**
 * The "a" lettermark, traced from Alyssa's logo file (LOGO_V3_ICON):
 * an espresso single-story "a" wrapped by burnt-orange and mustard arcs.
 * Coordinates match the 2000px source; paths are shared with utils/favicon.ts.
 */
export function LogoMark({
  className = ""
}: LogoMarkProps) {
  return <svg viewBox="507 517 990 990" className={className} fill="none" strokeWidth={70} aria-hidden="true" focusable="false" data-id="element-215" data-mp="25q3mx999h5vw">
      <path d="M885 575 A555 555 0 0 1 1440 1130 V1490" className="stroke-mustard" data-id="element-216" data-mp="2fh7zk2bgsenk" />
      <path d="M885 695 A435 435 0 0 1 1320 1130 V1490" className="stroke-dusty" data-id="element-217" data-mp="2ti294oa90lnt" />
      <circle cx="885" cy="1130" r="320" className="stroke-espresso" data-id="element-218" data-mp="2pfnu6f9pa61t" />
      <path d="M1205 1130 V1490" className="stroke-espresso" data-id="element-219" data-mp="2pecqsgk630b8" />
    </svg>;
}